import { Injectable } from '@angular/core';

import { isDefined } from '@frontend/sports/common/core/utils/extended-types';

import { isLinear } from '../../../base/utils/linear-utils';
import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { flattenPicks } from '../../../core/utils';
import { isStartingPriceSelected, isXCastPick } from '../../picks/services/betslip-pick-helpers';
import { getSelectedToken } from '../../reward-tokens/services/linear-reward-tokens.utils';
import { isFreebetToken } from '../../reward-tokens/services/reward-tokens.utils';
import { ITeaserBetPickState, ITeaserBetState } from '../../teaser-bet/state';
import { getSlipErrorsForType } from '../../validation/services/utils/betslip-errors-state-utils';
import { ICalculatorBetslipInput } from '../models';
import { ComboSlipType } from '../slip-type';
import BaseInputBuilder, { BetslipStateInput } from './base-input-builder';
import { getTeaserSlipId } from './slip.utils';

@Injectable()
export default class TeaserBetInputBuilder extends BaseInputBuilder {
    *getBetGeneratorInput(teaser: ITeaserBetState, betslipState: BetslipStateInput): Iterable<ICalculatorBetslipInput> {
        const pickList = flattenPicks(betslipState.picks.pickList);

        const teaserPicks = Object.entries(teaser.picks)
            .filter(([_, value]) => value.isSelected)
            .map(([_, value]) => this.getPick(value, pickList))
            .filter(isDefined);

        const rewardToken = getSelectedToken(betslipState.rewardTokens.tokens, betslipState.types.teaserBet);
        const stake = isFreebetToken(rewardToken) ? rewardToken.amount : teaser.stake;

        yield {
            slipId: getTeaserSlipId(),
            items: teaserPicks.map((pick) => {
                return {
                    ...this.getPickInfo(pick),
                    eachWayInfo: null,
                    isBanker: false,
                    isXCast: isXCastPick(pick),
                    isStartingPrice: isStartingPriceSelected(pick),
                };
            }),
            rewardToken,
            stake,
            hasError:
                betslipState.errors.betslipErrors.length > 0 ||
                betslipState.errors.betslipTypeErrors[BetslipType.Teaser].length > 0 ||
                getSlipErrorsForType(BetslipType.Teaser, betslipState.errors.slipErrors, betslipState.types, isLinear(betslipState)).length > 0,
            system: new ComboSlipType(),
        };
    }

    private getPick(pickState: ITeaserBetPickState, pickList: BetslipPick[]): BetslipPick {
        const pick = pickList.find((p) => p.id.toString() === pickState.id)!;

        return pick;
    }
}
